import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { ModeloService } from '../../../core/services/modelo.service';
import { AttributesService } from '../../../core/services/attributes.service';
import { Modelo } from '../../../shared/models/modelo';

@Component({
  selector: 'app-modelos',
  standalone: true,
  imports: [
    CommonModule, FormsModule, TableModule, ButtonModule,
    InputTextModule, DialogModule, SelectModule, ToastModule
  ],
  providers: [MessageService],
  templateUrl: './modelos.component.html'
})
export class ModelosComponent implements OnInit {
  modelos: Modelo[] = [];
  categories: any[] = [];
  modelo: Modelo = { name: '', isActive: true, categoryId: 0 };
  dialog: boolean = false;
  submitted: boolean = false;
  loading: boolean = true;

  constructor(
    private modeloService: ModeloService,
    private attributesService: AttributesService,
    private messageService: MessageService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.loading = true;

    this.attributesService.getActiveCategories().subscribe({
      next: (res) => {
        this.categories = res.map(c => ({ label: c.name, value: c.id }));

        this.modeloService.getAllModelos().subscribe({
          next: (data) => {
            this.modelos = data;
            this.loading = false;
            this.cdr.detectChanges();
          },
          error: (err) => {
            console.error('Error al cargar modelos:', err);
            this.messageService.add({severity: 'error', summary: 'Error', detail: 'No se pudieron cargar los modelos'});
            this.loading = false;
            this.cdr.detectChanges();
          }
        });
      },
      error: (err) => {
        console.error('Error al cargar categorías:', err);
        this.messageService.add({severity: 'error', summary: 'Error', detail: 'No se pudieron cargar las categorías'});
        this.loading = false;
        this.cdr.detectChanges();
      }
    });
  }

  openNew() {
    this.modelo = { name: '', isActive: true, categoryId: this.categories.length > 0 ? this.categories[0].value : 0 };
    this.submitted = false;
    this.dialog = true;
    this.cdr.detectChanges();
  }

  edit(modelo: Modelo) {
    this.modelo = { ...modelo };
    this.dialog = true;
    this.cdr.detectChanges();
  }

  toggle(modelo: Modelo) {
    this.modeloService.toggleStatus(modelo.id!).subscribe(() => {
      modelo.isActive = !modelo.isActive;
      this.messageService.add({severity: 'success', summary: 'Éxito', detail: 'Estado actualizado'});
      this.cdr.detectChanges();
    });
  }

  save() {
    this.submitted = true;

    if (this.modelo.name.trim() && this.modelo.categoryId !== null && this.modelo.categoryId !== undefined) {
      if (this.modelo.id) {
        this.modeloService.updateModelo(this.modelo.id, this.modelo).subscribe({
          next: () => {
            this.messageService.add({severity: 'success', summary: 'Éxito', detail: 'Modelo actualizado'});
            this.loadData();
            this.dialog = false;
            this.cdr.detectChanges();
          },
          error: (err) => this.messageService.add({severity: 'error', summary: 'Error', detail: 'Fallo al actualizar'})
        });
      } else {
        this.modeloService.createModelo(this.modelo).subscribe({
          next: () => {
            this.messageService.add({severity: 'success', summary: 'Éxito', detail: 'Modelo creado'});
            this.loadData();
            this.dialog = false;
            this.cdr.detectChanges();
          },
          error: (err) => this.messageService.add({severity: 'error', summary: 'Error', detail: 'Fallo al crear'})
        });
      }
    }
  }
}